// src/mixins/printMixin.js
import { hiprint, disAutoConnect } from 'vue-plugin-hiprint'

export default {
  data() {
    return {
      hiprintTemplate: null      // 保存当前页面的打印模板实例
    }
  },
  methods: {
    /**
     * 初始化打印设计器 / 加载模板
     * @param {string} storageKey - localStorage 中存储模板的 key
     * @returns {boolean} 是否初始化成功
     */
    initDesigner(storageKey) {
      disAutoConnect()
      if (!window.$) {
        console.error('❌ jQuery 未加载')
        return false
      }
      try {
        const saved = localStorage.getItem(storageKey)
        if (!saved) {
          this.$Notice.error({
            title: '错误提示',
            duration: 3,
            desc: '未配置打印模版！'
          })
          return false
        }
		debugger
        // 清空容器，避免重复构建
        const container = document.querySelector('#hiprint-printTemplate')
        if (container) container.innerHTML = ''
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: JSON.parse(saved),
          fontList: [
            { title: '微软雅黑', value: 'Microsoft YaHei' },
            { title: '宋体', value: 'SimSun' },
            { title: '黑体', value: 'SimHei' }
          ],
          onDataChanged: (type, json) => {
            console.log('📝 模板已变更', type, json)
          }
        })
        // 如果需要显示设计器可调用 design()，但这里只加载模板，不显示设计器
        // this.hiprintTemplate.design('#hiprint-printTemplate')
        console.log('✅ 打印模板加载完成')
        return true
      } catch (error) {
        this.hiprintTemplate = null
        console.error('❌ 加载打印模板失败:', error)
        return false
      }
    },

    /**
     * 确保打印模板已加载
     * @param {string} storageKey - localStorage 中的模板 key
     * @returns {boolean} 模板是否可用
     */
    ensurePrintTemplate(storageKey) {
      if (!this.hiprintTemplate) {
        return this.initDesigner(storageKey)
      }
      return true
    },

    /**
     * 执行打印
     * @param {Array|Object} data - 要打印的数据
     * @param {string} storageKey - 模板 key
     * @returns {boolean} 是否打印成功
     */
    printWithTemplate(data, storageKey) {
      if (!this.ensurePrintTemplate(storageKey)) {
        return false
      }
      try {
        this.hiprintTemplate.print(data)
        return true
      } catch (error) {
        console.error('打印失败:', error)
        this.$Notice.error({
          title: '错误提示',
          duration: 3,
          desc: '打印失败，请检查模版配置或数据格式'
        })
        return false
      }
    },

    /**
     * 跳转到打印模版配置页面
     * @param {string} routeName - 路由名称，例如 'printerpage' 或 'printercodepage'
     * @param {object} query - 可选的 query 参数
     */
    goSetPrintTemplate(routeName, query = {}) {
      this.$router.push({
        name: routeName,
        query
      })
    }
  }
}